import { createSlice} from '@reduxjs/toolkit';
import {apiCallBegan} from './api';
import _ from 'lodash';

function pad(num) {
  return num < 10 ? '0' + num : num;
}
let curDate = new Date()
let formattedDate = `${curDate.getFullYear()}-${pad(curDate.getMonth() + 1)}-${pad(curDate.getDate())}`

const slice = createSlice({
  name: 'flights',
  initialState: {
    list: [],
    loading: false,
    startDate: formattedDate,
    endDate: formattedDate,
    flightStatus: false,
    lastFetch: null,
    moveFlightStatus: null,
    flightWithLegs: null,
  },
  reducers: {
    // actions => action handlers
    // command - event
    flightsReceived: (state, action) => {
      state.list = action.payload;
      state.loading = false;
      state.lastFetch = Date.now();
    },

    flightsRequested: (state, action) => {
      state.loading = true;
    },

    flightsRequestFailed: (state, action) => {
      state.loading = false;
    },

    changeStartDate: (state, action) => {
      state.startDate = action.payload;
    },

    changeEndDate: (state, action) => {
      state.endDate = action.payload;
    },

    changeFlightStatus: (state, action) => {
      state.flightStatus = action.payload
    },

    moveFlightFailure: (state, action) => {
      console.log('ERR: MOVE FLIGHT FAILURE')
    },

    moveFlightSuccess: (state, action) => {
      state.moveFlightStatus = 'success'
      for (let i = 0; i < state.list.length; i++) {
        const flight = _.cloneDeep(state.list[i])
        let sameAircraft = action.payload.aircraftModel.key == flight.aircraftModel.key
        let sameFlightNum = action.payload.flightNumber == flight.flightNumber
        let sameDepAirport = action.payload.departure.airport.code == flight.departure.airport.code
        let sameArrAirport = action.payload.arrival.airport.code == flight.arrival.airport.code
        // if (sameAircraft && sameFlightNum && sameDepAirport && sameArrAirport) {
        // NEEDS-TESTING // test if keys are static
        if (flight.key == action.payload.key || sameAircraft && sameFlightNum && sameDepAirport && sameArrAirport) {
          state.list[i].departure.scheduledTime = action.payload.departure.scheduledTime
          state.list[i].departure.localScheduledTime = action.payload.departure.localScheduledTime
          state.list[i].arrival.scheduledTime = action.payload.arrival.scheduledTime
          state.list[i].arrival.localScheduledTime = action.payload.arrival.localScheduledTime
        }
      }
    },

    flightReceived: (state, action) => {
      state.flightWithLegs = action.payload
    },

    flightRequestFailed: (state, action) => {
      console.log('ERR: FLIGHT REQUEST FAILED')
    },
    // messageSent: (state, action) => {
    //   state.messageSuccess = true
    // },

    // messageFailed: (state, action) => {
    //   state.messageSuccess = false
    // }
  }
})

/*export*/ const { flightsReceived, flightsRequested, flightsRequestFailed, flightReceived, flightRequestFailed, moveFlightFailure, moveFlightSuccess} = slice.actions;
export const { changeStartDate, changeEndDate, changeFlightStatus } = slice.actions;
export default slice.reducer;

// Action Creators
// const url = `/flights?earliestDeparture=${startDate}&latestDeparture=${endDate}`;

export const loadFlights = (flightStart, flightEnd, flightStatus) => (dispatch, getState) => {
  const url = `/flights?earliestDeparture=${flightStart}&latestDeparture=${flightEnd}&includeInactive=${getState().entities.flights.flightStatus}`;

  return dispatch(
    apiCallBegan({
      url,
      onStart: flightsRequested.type,
      onSuccess: flightsReceived.type,
      onError: flightsRequestFailed.type
    })
  )
}

export const moveFlight = (key, output) => (dispatch, getState) => {
  // NOTE // doc url: flights/ {key} ? inventoryAllocationTypeKey={inventoryAllocationTypeKey} & suppressAscMessaging={suppressAscMessaging}
  // NOTE // inventoryAllocationTypeKey is used to send a message when an aircraft gets changed and only works with <DEFAULT>
  // NOTE // suppressAscMessaging is a boolean that dictates whether to send a message when the flight times change (true == no msg, false == msg. default is false)
  const url = `/flights/${key}`

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: output,
      onSuccess: moveFlightSuccess.type,
      onError: moveFlightFailure.type
    })
  )
}

export const loadFlight = (flightKey) => (dispatch, getState) => {
  const url = `/flights/${flightKey}`;

  return dispatch(
    apiCallBegan({
      url,
      // onStart: flightsRequested.type,
      onSuccess: flightReceived.type,
      onError: flightRequestFailed.type
    })
  )
}